import React from "react";
import { auth, db } from "../firebase";
import { Modal, ModalBody, Button, Form } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';
import 'react-day-picker/dist/style.css';

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subscribed: false,
      idsToShow: [],
      tables: [
        { idtable: "3-7x0b1tgh7agmf6hv", name: "Immersive Roulette",       img: "evolution-3-lr6t4k3lcd4qgyrk-2.jpg" },
        { idtable: "3-48z5pjps3ntvqc1b", name: "Auto-Roulette",             img: "evolution-3-48z5pjps3ntvqc1b-2.jpg" },
        { idtable: "3-vctlz20yfnmp1ylr", name: "Roulette",                   img: "Roulette.jpg" },
        { idtable: "3-wzg6kdkad1oe7m5k", name: "VIP Roulette",               img: "VIP-Roulette.jpg" },
        { idtable: "3-lkcbrbdckjxajdol", name: "Speed Roulette",             img: "Speed-Roulette.jpg" },
        { idtable: "3-PorROULigh000001", name: "Roleta Relâmpago",           img: "images.jpg" },
        { idtable: "3-LightningHindi01", name: "Hindi Lightning Roulette",   img: "Hindi-Roulette.jpg" },
        { idtable: "3-GoldVaultRo00001", name: "Gold Vault Roulette",        img: "French-Roulette-Gold.jpg" },
        { idtable: "3-n4jwxsz2x4tqitvx", name: "Japanese Roulette",          img: "Japanese-Roulette.jpg" },
        { idtable: "3-8clwnwrupuvf0osq", name: "Ruleta en Vivo",             img: "Ruleta-en-Vivo.jpg" },
        { idtable: "3-PorROU0000000001", name: "Roleta ao Vivo",             img: "Ruleta-Bola-Rapida-en-Vivo.jpg" },
        { idtable: "3-7nyiaws9tgqrzaz3", name: "Football Studio Roulette",   img: "Football-Studio-Roulette.jpg" },
        { idtable: "3-SpeedAutoRo00001", name: "Speed Auto Roulette",        img: "evolution-3-f1f4rm9xgh4j3u2z-2.jpg" },
        { idtable: "3-pv5q45yjhasyt46y", name: "Emperor Roulette",           img: "Emperor-Roulette.jpg" },
      ],
      showModal: false,
      selectedIds: [],
    };
  }

  handleShowModal = () => this.setState({ showModal: true });
  handleCloseModal = () => this.setState({ showModal: false });

  handleCheckboxChange = (id) => {
    this.setState(prevState => {
      const isSelected = prevState.selectedIds.includes(id);
      if (!isSelected && prevState.selectedIds.length >= 2) {
        toast.error("You can only select 2 tables with your subscription");
        return prevState;
      }
      const selectedIds = isSelected
        ? prevState.selectedIds.filter(item => item !== id)
        : [...prevState.selectedIds, id];
      return { selectedIds };
    });
  };

  handleAddTables = () => {
    this.setState(prevState => ({
      idsToShow: [...prevState.idsToShow, ...prevState.selectedIds],
      showModal: false,
    }));
    db.collection("users").doc(auth.currentUser.email).set({ idsToShow: this.state.selectedIds }, { merge: true });
  };

  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search);
    const sp = query.get('successpay');
    setTimeout(() => {
      this.getUser();
      if (sp === 'sus1-M' || sp === 'sus1-D') {
        db.collection("users").doc(auth.currentUser.email).set({ subscribed: true, idsToShow: [] });
      } else if (sp === 'sus2-M' || sp === 'sus2-D') {
        db.collection("users").doc(auth.currentUser.email).set({ subscribed: true, idsToShow: this.state.tables?.map(t => t.idtable) });
      }
    }, 1000);
  }

  getUser = async () => {
    if (auth.currentUser) {
      if (auth.currentUser.email === "info@stakebits.co") {
        window.location.href = "/admin";
      }
      await db.collection('users').doc(auth.currentUser?.email).get().then(doc => {
        const data = doc.data();
        this.setState(data);
        this.setState({ subscribed: data.subscribed === true });
      });
    } else {
      window.location.href = "/register";
    }
  };

  renderTables() {
    const filteredTables = this.state.tables?.filter(t => this.state.idsToShow.includes(t.idtable));

    if (this.state.subscribed === true) {
      return filteredTables.map(item => (
        <div key={item.idtable} className="col-12 col-sm-6 col-lg-4">
          <Link to={`/table/${item.idtable}/${item.name}`} className="sb-table-card">
            <div className="sb-table-card-img-wrap" style={{ height: 160 }}>
              <div style={{ backgroundImage: `url(/assets/tables/${item.img})` }} />
            </div>
            <div className="sb-table-card-body" style={{ padding: '0.75rem 1rem' }}>
              <p className="sb-table-card-title" style={{ fontSize: '0.875rem' }}>{item.name}</p>
            </div>
            <div className="sb-table-card-footer" style={{ padding: '0.5rem 1rem' }}>
              Evolution Gaming
            </div>
          </Link>
        </div>
      ));
    }

    return (
      <div className="col-12">
        <div style={{
          background: 'var(--sb-bg-card)',
          border: '1px solid var(--sb-border)',
          borderRadius: 'var(--sb-radius-lg)',
          padding: '3rem 2rem',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>🎡</div>
          <h4 style={{ color: 'var(--sb-text-primary)', fontWeight: 700, marginBottom: '0.5rem' }}>
            Subscribe to access tables
          </h4>
          <p style={{ color: 'var(--sb-text-secondary)', fontSize: '0.9rem', maxWidth: 380, margin: '0 auto 1.5rem' }}>
            Get a StakeBits subscription to unlock real-time stats for live Evolution roulette tables.
          </p>
          <Link to="/pricing" className="btn-sb-primary">
            View pricing plans
          </Link>
        </div>
      </div>
    );
  }

  renderProfile() {
    const user = auth.currentUser;
    const creationTime = user?.metadata?.creationTime?.slice(0, 16) || '—';
    const displayName = this.state.name || user?.displayName || 'User';
    const email = user?.email || '—';
    const tablesCount = this.state.idsToShow?.length || 0;

    return (
      <main>

        {/* ── Page header ─────────────────────────────────── */}
        <section style={{
          padding: '3.5rem 0 2.5rem',
          background: 'radial-gradient(ellipse 80% 50% at 50% -10%, rgba(59,130,246,0.09) 0%, transparent 60%), var(--sb-bg-base)',
          borderBottom: '1px solid var(--sb-border)',
        }}>
          <div className="container">
            <div className="sb-section-label" style={{ marginBottom: '0.5rem' }}>Dashboard</div>
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
              <div>
                <h1 style={{ fontSize: '1.8rem', fontWeight: 800, color: 'var(--sb-text-primary)', letterSpacing: '-0.03em', marginBottom: '0.25rem' }}>
                  My tables
                </h1>
                <p style={{ color: 'var(--sb-text-secondary)', fontSize: '0.9rem', margin: 0 }}>
                  Live stats from Evolution roulette tables
                </p>
              </div>
              {this.state.subscribed && this.state.idsToShow.length > 0 && (
                <button className="btn-sb-outline" style={{ fontSize: '0.82rem' }} onClick={this.handleShowModal}>
                  + Manage tables
                </button>
              )}
            </div>
          </div>
        </section>

        {/* ── Select tables modal ──────────────────────────── */}
        <Modal show={this.state.showModal} onHide={this.handleCloseModal} centered>
          <Modal.Header closeButton style={{ background: 'var(--sb-bg-elevated)', borderBottom: '1px solid var(--sb-border)' }}>
            <Modal.Title style={{ color: 'var(--sb-text-primary)', fontSize: '1rem', fontWeight: 600 }}>Select tables</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ background: 'var(--sb-bg-elevated)', maxHeight: '60vh', overflowY: 'auto' }}>
            <p style={{ color: 'var(--sb-text-secondary)', fontSize: '0.82rem', marginBottom: '1rem' }}>
              Choose up to 2 tables for your subscription.
            </p>
            <Form>
              {this.state.tables.map(table => (
                <div
                  key={table.idtable}
                  onClick={() => this.handleCheckboxChange(table.idtable)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '0.75rem',
                    padding: '0.6rem 0.75rem', borderRadius: 'var(--sb-radius-sm)',
                    cursor: 'pointer', marginBottom: '0.25rem',
                    background: this.state.selectedIds.includes(table.idtable) ? 'var(--sb-accent-glow)' : 'transparent',
                    border: `1px solid ${this.state.selectedIds.includes(table.idtable) ? 'var(--sb-border-accent)' : 'transparent'}`,
                    transition: 'all 0.15s',
                  }}
                >
                  <input
                    type="checkbox"
                    readOnly
                    checked={this.state.selectedIds.includes(table.idtable)}
                    style={{ accentColor: 'var(--sb-accent)', flexShrink: 0 }}
                  />
                  <span style={{ color: 'var(--sb-text-primary)', fontSize: '0.875rem' }}>{table.name}</span>
                </div>
              ))}
            </Form>
          </Modal.Body>
          <Modal.Footer style={{ background: 'var(--sb-bg-elevated)', borderTop: '1px solid var(--sb-border)' }}>
            <button className="btn btn-dark" onClick={this.handleCloseModal}>Cancel</button>
            <button className="btn btn-primary" onClick={this.handleAddTables}>Save selection</button>
          </Modal.Footer>
        </Modal>

        {/* ── Tables grid ─────────────────────────────────── */}
        <section style={{ padding: '2.5rem 0', background: 'var(--sb-bg-surface)' }}>
          <div className="container">

            {/* Empty state — subscribed but no tables selected */}
            {this.state.subscribed && this.state.idsToShow.length === 0 && (
              <div style={{
                background: 'var(--sb-bg-card)',
                border: '1px solid var(--sb-border-accent)',
                borderRadius: 'var(--sb-radius-lg)',
                padding: '2rem',
                marginBottom: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '1.5rem',
                flexWrap: 'wrap',
              }}>
                <div style={{ flex: 1, minWidth: 200 }}>
                  <h5 style={{ color: 'var(--sb-text-primary)', fontWeight: 700, marginBottom: '0.3rem' }}>
                    You're subscribed — pick your tables
                  </h5>
                  <p style={{ color: 'var(--sb-text-secondary)', fontSize: '0.875rem', margin: 0 }}>
                    Select up to 2 tables to add to your dashboard.
                  </p>
                </div>
                <button className="btn-sb-primary" onClick={this.handleShowModal}>
                  Select tables
                </button>
              </div>
            )}

            <div className="row g-3">
              {this.renderTables()}
            </div>
          </div>
        </section>

        {/* ── Profile card + stats ─────────────────────────── */}
        <section style={{ padding: '3rem 0' }}>
          <div className="container">
            <div className="row g-4">

              {/* Profile card */}
              <div className="col-12 col-lg-5">
                <div style={{
                  background: 'var(--sb-bg-card)',
                  border: '1px solid var(--sb-border)',
                  borderRadius: 'var(--sb-radius-lg)',
                  overflow: 'hidden',
                }}>
                  {/* Card top stripe */}
                  <div style={{
                    height: 72,
                    background: 'linear-gradient(135deg, var(--sb-bg-elevated) 0%, rgba(59,130,246,0.12) 100%)',
                    borderBottom: '1px solid var(--sb-border)',
                  }} />

                  <div style={{ padding: '0 1.75rem 1.75rem', marginTop: -28 }}>
                    {/* Avatar */}
                    <div style={{
                      width: 56, height: 56,
                      borderRadius: '50%',
                      background: 'var(--sb-accent)',
                      border: '3px solid var(--sb-bg-card)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: '1.25rem', fontWeight: 700, color: '#fff',
                      marginBottom: '0.75rem',
                    }}>
                      {displayName.charAt(0).toUpperCase()}
                    </div>

                    <h4 style={{ color: 'var(--sb-text-primary)', fontWeight: 700, fontSize: '1.1rem', marginBottom: '0.2rem' }}>
                      {displayName}
                    </h4>
                    <p style={{ color: 'var(--sb-text-muted)', fontSize: '0.82rem', marginBottom: '1.25rem' }}>{email}</p>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                      {[
                        { label: 'Member since', value: creationTime },
                        { label: 'Subscription', value: this.state.subscribed ? 'Active' : 'Inactive', accent: this.state.subscribed },
                        { label: 'Tables tracked', value: `${tablesCount} table${tablesCount !== 1 ? 's' : ''}` },
                      ].map(({ label, value, accent }) => (
                        <div key={label} style={{
                          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                          padding: '0.6rem 0',
                          borderBottom: '1px solid var(--sb-border)',
                        }}>
                          <span style={{ color: 'var(--sb-text-muted)', fontSize: '0.8rem' }}>{label}</span>
                          <span style={{
                            fontSize: '0.82rem', fontWeight: 600,
                            color: accent ? 'var(--sb-success)' : 'var(--sb-text-primary)',
                          }}>
                            {accent && <span style={{ display: 'inline-block', width: 7, height: 7, borderRadius: '50%', background: 'var(--sb-success)', marginRight: 6 }} />}
                            {value}
                          </span>
                        </div>
                      ))}
                    </div>

                    {!this.state.subscribed && (
                      <Link to="/pricing" className="btn-sb-primary" style={{ marginTop: '1.25rem', width: '100%', justifyContent: 'center', display: 'flex' }}>
                        Upgrade subscription
                      </Link>
                    )}
                  </div>
                </div>
              </div>

              {/* Right info cards */}
              <div className="col-12 col-lg-7">
                <div className="row g-3 h-100">

                  {[
                    { icon: '📊', title: 'Spin History', desc: 'Full history of every spin with result, timestamp, and number type across all your tracked tables.' },
                    { icon: '🌡️', title: 'Hot & Cold Numbers', desc: 'Identify which numbers are on a streak and which haven\'t appeared recently — updated after every spin.' },
                    { icon: '🎡', title: 'Tier Breakdowns', desc: 'Orphans, Neighbours of Zero, Third of the Wheel, and Zero Game — all tracked in real time.' },
                    { icon: '⚡', title: 'Real-time Data', desc: 'All charts and stats update live as spins come in. No manual refresh needed.' },
                  ].map(({ icon, title, desc }) => (
                    <div key={title} className="col-12 col-sm-6">
                      <div style={{
                        background: 'var(--sb-bg-card)',
                        border: '1px solid var(--sb-border)',
                        borderRadius: 'var(--sb-radius-md)',
                        padding: '1.25rem',
                        height: '100%',
                        transition: 'border-color 0.2s',
                      }}
                        onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--sb-border-accent)'}
                        onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--sb-border)'}
                      >
                        <div style={{ fontSize: '1.35rem', marginBottom: '0.6rem' }}>{icon}</div>
                        <h6 style={{ color: 'var(--sb-text-primary)', fontWeight: 700, fontSize: '0.9rem', marginBottom: '0.4rem' }}>{title}</h6>
                        <p style={{ color: 'var(--sb-text-secondary)', fontSize: '0.8rem', lineHeight: 1.6, margin: 0 }}>{desc}</p>
                      </div>
                    </div>
                  ))}

                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
    );
  }

  render() {
    return this.renderProfile();
  }
}

export default Profile;
